import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";

export function goalMarketingRegister(formData) {
  return (dispatch) => {
    return request(requestConfig.goalMarketingRegister(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.GOAL_MARKETING, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with goal marketing data: " + error);
      });
  };
}
export function goalVideoPodcastBlogs() {
    return (dispatch) => {
      return request(requestConfig.goalVideoPodcastBlogs())
        .then((json) => {
          json && dispatch({ type: ACTION.GOAL_VIDEO_PODCAST_BLOG, data: json.data });
          return json;
        })
        .catch((error) => {
          console.log("Got Error with goal marketing data: " + error);
        });
    };
  }
